import { createContext } from 'react';

import { FlagsState } from './types';

export const FlagsContext = createContext<FlagsState | undefined>(undefined);
